import { combineReducers } from 'redux';
import { APP } from "../constants";
import appReducer from './appReducer';
import homeReducer from './homeReducer';
import viewerReducer from './viewerReducer';
import imageReducer from './imageReducer';
import reportReducer from './reportReducer';
import plotReducer from './plotReducer';
import plotViewerReducer from './plotViewerReducer';
import downloadReducer from './downloadReducer';

const appReducers = combineReducers({
  app: appReducer,
  home: homeReducer,
  viewer: viewerReducer,
  image: imageReducer,
  report: reportReducer,
  plot: plotReducer,
  plotViewer: plotViewerReducer,
  download: downloadReducer,
});

const rootReducer = (state, action) => {
  if (action.type === APP.RESET_STORE) {
    return appReducers(undefined, action);
  }
  return appReducers(state, action);
};

export default rootReducer;
